export const dataLibZ = [{
  word: 'zonng',
  partOfSpeech: 'N',
  definition: ['fingernail', 'toenail'],
  egSentenceKw: 'Yo té ni pou tiyé zonng li.',
  egSentenceEn: 'They had to remove his fingernail.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. les ongles]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'zé',
  partOfSpeech: 'N',
  definition: ['egg'],
  egSentenceKw: 'Koté poul-la ki ka ponn sé zé sala?',
  egSentenceEn: 'Where is the hen that layed these eggs?',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. les oeufs]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'zanno',
  partOfSpeech: 'N',
  definition: ['earring'],
  egSentenceKw: 'Fanm-lan ni dé gwo zanno.',
  egSentenceEn: 'The woman has two big earrings.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. les anneaus]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'zòt',
  partOfSpeech: 'PRO',
  definition: ['you', 'your (pl)'],
  egSentenceKw: 'Si zòt vini denmen mwen kay bay zòt lajan-an.',
  egSentenceEn: 'If you come tomorrow I\'ll give you the money.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. vous autres]',
  dialect: '🇱🇨',
  variant: ['hò', 'hòt', 'zò'],
}, {
  word: 'zatolan',
  partOfSpeech: 'PRO',
  definition: ['Common ground dove', '(Columbina passerina)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: null,
},
];
